'use client';

import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING._4};
`;
